import React from "react";
import { formatPrice, formatePriceFn, formatPriceWithRate } from "../../../../helper/commonFunction";
import { getActiveCode, getActiveRate } from "../../../../helper/currencyState";
import { useSelector } from "react-redux";
import AedChargeNote from "../../../../component/AedChargeNote";
export const PriceBreakdown = ({ totalPrice, bookingDetails }) => {
  // let totalPrice = adults * adultFinalPrice;
  // if (infantFinalPrice && infantFinalPrice > 0) {
  //   totalPrice = totalPrice + child * childFinalPrice + infants * infantFinalPrice;
  // } else {
  //   totalPrice = totalPrice + (child + infants) * childFinalPrice;
  // }
  // const onlineServiceFeeAmount = (totalPrice * onineServicesFees) / 100;
  const totalAdult = bookingDetails?.paymentService?.paxInformations?.find(data => data?.type === 'adult')
  const totalChild = bookingDetails?.paymentService?.paxInformations?.find(data => data?.type === 'child')
  const totalInfant = bookingDetails?.paymentService?.paxInformations?.find(data => data?.type === 'infant')
  const adult = bookingDetails?.paymentService?.paxInformations?.reduce((count, pax) => {
    return pax.type === 'adult' ? count + 1 : count;
  }, 0);
  const child = bookingDetails?.paymentService?.paxInformations?.reduce((count, pax) => {
    return pax.type === 'child' ? count + 1 : count;
  }, 0);
  const infant = bookingDetails?.paymentService?.paxInformations?.reduce((count, pax) => {
    return pax.type === 'infant' ? count + 1 : count;
  }, 0);
  let totalTax = 0;
  let adultFare = 0, childFare = 0, infantFare = 0;
  if (adult > 0) {
    totalTax += (adult * totalAdult?.taxAmount)
    adultFare += (adult * totalAdult?.baseAmount)
  }
  if (child > 0) {
    totalTax += (child * totalChild?.taxAmount)
    childFare += (child * totalChild?.baseAmount)
  }
  if (infant > 0) {
    totalTax += (infant * totalInfant?.taxAmount)
    infantFare += (infant * totalInfant?.baseAmount)
  }
  let totalAmount = adultFare + childFare + infantFare + totalTax
  if(bookingDetails?.paymentService?.onlineServiceFeeAmount) totalAmount += bookingDetails?.paymentService?.onlineServiceFeeAmount
  const { agentActiveCurrency, displayPrice } = useSelector((state) => state.userData);
  // Booking detail shows the amount in the currency the booking was MADE in
  // (stored display_currency + conversion_rate), NOT the live currency switcher.
  const hasBookedCurrency = !!bookingDetails?.display_currency;
  const bookingCurrency = hasBookedCurrency ? bookingDetails?.display_currency : getActiveCode();
  const bookingRate = hasBookedCurrency ? (Number(bookingDetails?.conversion_rate) || 1) : getActiveRate();
  const ageGroup = {
    adult: {
      name: "Adult",
      count: adult,
      price: totalAdult?.baseAmount || 0,
    },

    child: {
      name: "Child",
      count: child,
      price: totalChild?.baseAmount || 0,
    },

    infant: {
      name: "Infant",
      count: infant,
      price: totalInfant?.baseAmount || 0,
    },
  };
  return (
    <div className="hw-after--bookingWidget price-backup">
      {/* <h4 className="h4 mb-0">Price Breakup</h4> */}
      <div className="hw-passenger--fareSummary__tbody">
        {Object.keys(ageGroup).map((_ageGroup) => {
          if (ageGroup?.[_ageGroup]?.count <= 0) return null;

          return (
            <div
              className="hw-passenger--fareSummary__tbodyRowMain"
              key={_ageGroup}
            >
              <div className="hw-passenger--fareSummary__tbodyTR">
                <span className="hw-black900 hw-fontBold hw-text14">
                  {ageGroup?.[_ageGroup]?.name} x{" "}
                  {ageGroup?.[_ageGroup]?.count}
                </span>

                <span className="hw-black900 hw-fontBold hw-text14">
                  {formatePriceFn(bookingCurrency,
                    formatPriceWithRate(
                      ageGroup?.[_ageGroup]?.price *
                      ageGroup?.[_ageGroup]?.count,
                      bookingRate,
                      true
                    ),
                    displayPrice
                  )}
                </span>
              </div>
            </div>
          );
        })}
      </div>
      {
        totalTax > 0 && <div className="hw-passenger--fareSummary__thead">
          <span className="hw-black900 hw-fontBold hw-text14">Taxes and Fees</span>
          <span className="hw-black900 hw-fontBold hw-text14">{formatePriceFn(bookingCurrency, formatPriceWithRate(totalTax, bookingRate, true), displayPrice)}</span>
        </div>
      }
      {
        bookingDetails?.paymentService?.onlineServiceFeeAmount && <div className="hw-passenger--fareSummary__thead">
          <span className="hw-black900 hw-fontBold hw-text14">Service Fees</span>
          <span className="hw-black900 hw-fontBold hw-text14">{formatePriceFn(bookingCurrency, formatPriceWithRate(bookingDetails?.paymentService?.onlineServiceFeeAmount, bookingRate, true), displayPrice)}</span>
        </div>
      }
      {/* <div className="hw-passenger--fareSummary__tbody">
        <div className="hw-passenger--fareSummary__tbodyRowMain">
          <div className="hw-passenger--fareSummary__tbodyTR">
            <span className="hw-black900 hw-fontBold">Taxes and Fees</span>
            <span className="hw-black900 hw-fontBold">2 AED</span>
          </div>
        </div>
      </div> */}
      <div className="hw-passenger--fareSummary__tfoot">
        <span className="hw-black900 hw-fontBold">Total</span>
        <span className="hw-primary hw-fontBold">{formatePriceFn(bookingCurrency, formatPriceWithRate(totalAmount, bookingRate, true), displayPrice)}</span>
      </div>
      {/* <AedChargeNote amount={totalAmount} currencyCode={bookingCurrency} /> */}
    </div>
  );
};